import { Parameter$getWebShopsSearchV1 } from '~/api/gen'
import { NormalizedConditions } from '~/features/shared/search/shop/types'

export const convertNormalizedConditionsToParameters = (
  conditions: NormalizedConditions,
  options: Parameter$getWebShopsSearchV1 = {}
): Parameter$getWebShopsSearchV1 => {
  const params = new URLSearchParams(conditions.additionalQueries)
  return {
    sort_type:
      conditions.sort === 'alphabetically' ? 'shop_name' : 'popularity',
    search_word: conditions.searchWord,
    business_type:
      conditions.shopType === 'all' ? undefined : conditions.shopType,
    brand_id: conditions.brand?.id,
    pageno: Number(params.get('pageno')) || 1,
    ...options,
  }
}
